import './productHeroSection.css';
import ProductHeroMetaSection from './ProductHeroMetaSection';

type ProductHeroSectionProps = {
  productImageSrc: string;
  readMoreIconSrc: string;
  fullDescription?: string;
  productTitle?: string;
  brandText?: string;
  chips?: string[];
  partialTextMinChars?: number;
  purchaseUrl?: string;
  websiteUrl?: string;
  brandName?: string;
};

export default function ProductHeroSection({
  productImageSrc,
  readMoreIconSrc,
  fullDescription = '',
  productTitle = '',
  brandText = '',
  chips = [],
  partialTextMinChars = 90,
  purchaseUrl,
  websiteUrl,
  brandName,
}: ProductHeroSectionProps) {
  return (
    <>
      {productImageSrc ? (
        <section className="rid-expanded__image-card">
          <img src={productImageSrc} alt={`${productTitle} packaging`} />
        </section>
      ) : null}
      <ProductHeroMetaSection
        readMoreIconSrc={readMoreIconSrc}
        fullDescription={fullDescription}
        productTitle={productTitle}
        brandText={brandText}
        chips={chips}
        partialTextMinChars={partialTextMinChars}
        purchaseUrl={purchaseUrl}
        websiteUrl={websiteUrl}
        brandName={brandName}
      />
    </>
  );
}
